import { useQuery } from "@tanstack/react-query";

import { toApiError } from "../../lib/apiError";
import type { ApiClient } from "../client";
import { useApiClient } from "../useApiClient";

import type { TradeSortOrder } from "./useTrades";

export const TRADE_GROUPS_QUERY_KEY = ["trade-groups"] as const;

// Shared query definition reused by the hook and by nav prefetch.
export function tradeGroupsQueryOptions(
  client: ApiClient,
  params: ListTradeGroupsQuery = {},
) {
  return {
    queryKey: [...TRADE_GROUPS_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/trades/groups", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error(toApiError(error, "Failed to list trade groups"));
      }
      return data;
    },
  };
}

export type ListTradeGroupsQuery = {
  account_id?: string[];
  status?: "all" | "open" | "closed" | "partial";
  screen_id?: string;
  sort_order?: TradeSortOrder;
  window_minutes?: number;
  min_run?: number;
  // Date-range filter (UTC ISO) -- mirrors GET /trades so a calendar day
  // drill-in survives the Group-runs toggle (L0-U14 item 1, ADR 0031).
  opened_after?: string;
  opened_before?: string;
};

export function useTradeGroups(params: ListTradeGroupsQuery = {}, enabled = true) {
  const client = useApiClient();
  return useQuery({
    ...tradeGroupsQueryOptions(client, params),
    enabled,
  });
}
